import React from 'react';

import MenuView from './MenuView';

function Menu(props) {
  return <MenuView {...props} />;
}

export default Menu;
